import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

var cards = new Swiper(".cards-carousel", {
	autoplay: {
		enabled: true,
		delay: 6000,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});


var programsCards = new Swiper('[date-carousel="programsCards"]', {
  spaceBetween: 16,
  slidesPerView: 1.2,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: '3',
    },
  },
});


var programs = new Swiper('[date-carousel="programs"]', {
  spaceBetween: 0,
  slidesPerView: 1,
  navigation: {
    nextEl: '.nextProgram',
    prevEl: '.prevProgram',
  },
  thumbs: {
    swiper: programsCards,
  },
});

var latestEvents = new Swiper('[date-carousel="latestEvents"]', {
  slidesPerView: 'auto',
  spaceBetween: 12,
  navigation: {
    nextEl: '.nextEvent',
    prevEl: '.prevEvent',
  },
});

var counters = new Swiper('[date-carousel="counters"]', {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 1500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});

var relatedCards = new Swiper('[date-carousel="relatedCards"]', {
  slidesPerView: 1,
  spaceBetween: 24,
  navigation: {
    nextEl: '.nextRelatedCards',
    prevEl: '.prevRelatedCards',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1280: {
      slidesPerView: 3,
    },
  },
});

var latestEventsMobile = new Swiper('[date-carousel="latestEventsMobile"]', {
  slidesPerView: 1.25,
  spaceBetween: 12,
  navigation: {
    nextEl: '.nextEventMobile',
    prevEl: '.prevEventMobile',
  },
});

var imageGalleryThumb = new Swiper('[date-carousel="imageGalleryThumb"]', {
  spaceBetween: 15,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});

var imageGallery = new Swiper('[date-carousel="imageGallery"]', {
  navigation: {
    nextEl: '.nextImageGallery',
    prevEl: '.prevImageGallery',
  },
  thumbs: {
    swiper: imageGalleryThumb,
  },
});

var imageGalleryMobile = new Swiper('[date-carousel="imageGalleryMobile"]', {
  navigation: {
    nextEl: '.nextImageGallery',
    prevEl: '.prevImageGallery',
  },
});

var sponsorLogos = new Swiper('[date-carousel="sponsorLogos"]', {
  spaceBetween: 44,
  slidesPerView: 'auto',
  freeMode: true,
  breakpoints: {
    768: {
      spaceBetween: 88,
    },
  },
  navigation: {
    nextEl: '.nextSponsorLogos',
    prevEl: '.prevSponsorLogos',
  },
});